import { RouteConfig } from "vue-router";

export const ShopInventoryRoutes: Array<RouteConfig> = [
    {
        path: 'editor/new-invoice/:invoice_type',
        name: 'shop-invoice-editor-create',
        component: () => import(/* webpackChunkName: "shop-invoice-editor-create" */ './views/ShopInvoiceEditorCreateInvoice.vue'),
    }, {
        path: 'editor/:invoice_id',
        name: 'shop-invoice-editor-update',
        component: () => import(/* webpackChunkName: "shop-invoice-editor-update" */ './views/ShopInvoiceEditorUpdateInvoice.vue'),
    }
]